import { Injectable, inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	Route,
	RouterStateSnapshot,
	UrlSegment,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { AuthState } from 'src/shared/state/auth.state';

@Injectable({
	providedIn: 'root',
})
export class CrisisTeamRoleGuard {
	private store = inject(Store);

	isCrisisTeam: Observable<boolean> = this.store.select(
		AuthState.isCrisisTeam
	);

	canActivate(
		_next: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	): Observable<boolean> {
		return this.isCrisisTeam;
	}

	canLoad(_route: Route, _segments: UrlSegment[]): boolean {
		return this.store.selectSnapshot(AuthState.isCrisisTeam);
	}
}
